module.exports = __webpack_public_path__ + "img/box_fruit.088b120d.png";